"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "carnate": {
    "5625ca7b": [{
      "hkey": "e1e5a34e",
      "slug": "carnate",
      "name": "Carnate",
      "primary": true,
      "skipSearch": false
    }],
    "camperia": [{
      "hkey": "e1e5a34e",
      "slug": "carnate",
      "name": "Carnate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "927ad676": [{
      "hkey": "e1e5a34e",
      "slug": "carnate",
      "name": "Carnate",
      "primary": true,
      "skipSearch": false
    }],
    "carnate-inferiore": [{
      "hkey": "e1e5a34e",
      "slug": "carnate",
      "name": "Carnate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9abd9ef9": [{
      "hkey": "e1e5a34e",
      "slug": "carnate",
      "name": "Carnate",
      "primary": true,
      "skipSearch": false
    }],
    "carnate-superiore": [{
      "hkey": "e1e5a34e",
      "slug": "carnate",
      "name": "Carnate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "49e292bc": [{
      "hkey": "e1e5a34e",
      "slug": "carnate",
      "name": "Carnate",
      "primary": true,
      "skipSearch": false
    }],
    "fornace": [{
      "hkey": "e1e5a34e",
      "slug": "carnate",
      "name": "Carnate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0760b2d2": [{
      "hkey": "e1e5a34e",
      "slug": "carnate",
      "name": "Carnate",
      "primary": true,
      "skipSearch": false
    }],
    "passirano": [{
      "hkey": "e1e5a34e",
      "slug": "carnate",
      "name": "Carnate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a5178ad7": [{
      "hkey": "e1e5a34e",
      "slug": "carnate",
      "name": "Carnate",
      "primary": true,
      "skipSearch": false
    }],
    "stazione": [{
      "hkey": "e1e5a34e",
      "slug": "carnate",
      "name": "Carnate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;